import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { Classes, Dialog, FormGroup, InputGroup, TextArea, Tag, HTMLSelect, Button } from "@blueprintjs/core";
import { AppStore } from "../../stores/AppStore";
import { toast } from "react-toastify";
import { DateRangePicker } from "../utils/DateRangePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { SugestoesMelhoriasAdminStore } from "../../stores/admin/SugestoesMelhoriasAdminStore";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ptBR } from "@mui/x-date-pickers/locales";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";


@observer
export default class SugestoesMelhoriasAdminPage extends React.Component<{}, {}> {

  obs = observable({
    titulo: "" as string,
    descricao: "" as string,
    melhoria_selecionada: null as any,
    open_form: false as boolean,
    selectedPeriod: [] as any,
    date1: "" as string,
    date2: "" as string,
    id: "" as string,
    sugestoes_page: 1 as number,
    status_filtro: null as number | null,
    status_selecionado: null as number,
    data_prevista: null as Dayjs,
    motivo_recusa: "" as string,
    selectedDeliveryPeriod: [] as any,
    data_entrega_inicial: "" as string,
    data_entrega_final: "" as string,
  });

  readonly TAG_STYLE: React.CSSProperties = {
    width: "70%",
    textAlign: "center"
  };

  /**
  * Executa ações iniciais após a montagem do componente.
  *
  * Define o título da página através da `AppStore` e carrega a primeira página
  * da listagem de sugestões abertas pelo usuário logado.
  *
  * @returns {void} Não retorna valor.
  */

  async componentDidMount() {
    AppStore.setTitle("Sugestões de Melhorias");

    await SugestoesMelhoriasAdminStore.handleConsultaStatus();
    await this.handleBuscaSugestao(1);
  }

  /**
  * Atualiza o período selecionado para consulta das solicitações.
  *
  * Armazena o período informado e atualiza as datas inicial e final utilizadas nos filtros da consulta. 
  * As datas válidas são formatadas no padrão `YYYY-MM-DD`.
  *
  * Caso o período informado esteja vazio ou incompleto, limpa os valores de
  * `this.obs.date1` e `this.obs.date2`.
  *
  * @param {any} val - Período selecionado, contendo a data inicial e a data final.
  * @returns {void} Não retorna valor.
  */

  handleDateSolicitacaoChange = (val: any) => {

    this.obs.selectedPeriod = val;

    if (!val || !val[0] || !val[1]) {
      this.obs.date1 = "";
      this.obs.date2 = "";
      return;
    }

    this.obs.date1 = moment(val[0]).format("YYYY-MM-DD");
    this.obs.date2 = moment(val[1]).format("YYYY-MM-DD");
  };

  handleDateEntregaChange = (val: any) => {
    this.obs.selectedDeliveryPeriod = val;

    if (!val || !val[0] || !val[1]) {
      this.obs.data_entrega_inicial = "";
      this.obs.data_entrega_final = "";
      return;
    }

    this.obs.data_entrega_inicial = moment(val[0]).format("YYYY-MM-DD");
    this.obs.data_entrega_final = moment(val[1]).format("YYYY-MM-DD");
  };

  /**
  * Busca as sugestões de melhoria.
  *
  * Quando um período estiver selecionado, realiza a consulta filtrando
  * pelas datas inicial e final. Caso nenhum período seja informado,
  * consulta todas as sugestões de forma paginada.
  *
  * @async
  * @param {number} page - Página que será consultada. Valor padrão: `1`.
  * @returns {Promise<void>} Não retorna valor diretamente.
  */

  handleBuscaSugestao = async (page: number = 1) => {

    this.obs.sugestoes_page = page;

    await SugestoesMelhoriasAdminStore.handleConsultaSugestao(
      page,
      this.obs.date1,
      this.obs.date2,
      this.obs.status_filtro,
      this.obs.data_entrega_inicial,
      this.obs.data_entrega_final,
      this.obs.id.trim()
    );
  };

  /**
  * Fecha o modal de cadastro sem descartar o que já foi digitado.
  *
  * O conteúdo é preservado propositalmente: fechar o modal por engano no meio
  * do preenchimento não pode custar o texto e os anexos do usuário. Para zerar
  * os campos existe o botão "Limpar".
  *
  * @returns {void} Não retorna valor.
  */

  handleCloseForm = () => {

    this.obs.melhoria_selecionada = null;
    this.obs.status_selecionado = null;
    this.obs.data_prevista = null;
    this.obs.motivo_recusa = "";
    this.obs.open_form = false;

  };

  /**
  * Salva as alterações realizadas em uma sugestão de melhoria.
  *
  * Valida se existe uma sugestão selecionada, se uma situação foi informada
  * e se a data prevista não é anterior à data atual. Quando os dados são válidos,
  * formata a data prevista e solicita ao store administrativo a atualização da
  * sugestão.
  *
  * Após uma atualização bem-sucedida, fecha o formulário de edição e atualiza
  * novamente a listagem de sugestões na página atual.
  *
  * Em caso de dados inválidos, exibe uma mensagem de aviso ao usuário e
  * interrompe o processamento.
  *
  * @async
  * @returns {Promise<void>} Não retorna valor diretamente.
  */

  handleSalvarAlteracoes = async () => {

    const sugestao = this.obs.melhoria_selecionada;

    if (!sugestao) {
      return;
    }

    if (this.obs.status_selecionado === null) {

      toast.warning("Selecione uma situação.");

      return;
    }

    if (this.obs.data_prevista && this.obs.data_prevista.startOf("day").isBefore(dayjs().startOf("day"))) {

      toast.warning("A data prevista não pode ser anterior à data atual.");

      return;
    }

    if (this.isStatusRecusada() && !this.obs.motivo_recusa.trim()) {
      toast.warning("Informe o motivo da recusa.");
      return;
    }

    const data_prevista = this.obs.data_prevista ? this.obs.data_prevista.format("YYYY-MM-DD") : null;

    const sucesso = await SugestoesMelhoriasAdminStore.handleAtualizarSugestao(
        sugestao._id, 
        this.obs.status_selecionado, 
        data_prevista, 
        this.isStatusRecusada() ? this.obs.motivo_recusa.trim() : null
      );

    if (!sucesso) {
      return;
    }

    this.handleCloseForm();

    await this.handleBuscaSugestao(this.obs.sugestoes_page);

  };

  /**
  * Abre o modal de detalhe de uma sugestão já enviada.
  *
  * Armazena a linha selecionada na listagem e habilita a exibição do modal,
  * que apresenta descrição completa, status e imagens anexadas.
  *
  * @param {any} row Objeto da sugestão selecionada na listagem.
  * @returns {void} Não retorna valor.
  */

  handleOpenDetalhe = async (row: any) => {

    const detalhe = await SugestoesMelhoriasAdminStore.handleConsultaDetalhe(row._id);

    if (!detalhe) {
      return;
    }

    this.obs.melhoria_selecionada = detalhe;

    this.obs.status_selecionado = Number(detalhe.status);

    this.obs.data_prevista = detalhe.data_prevista ? dayjs(detalhe.data_prevista.substring(0, 10)) : null;

    this.obs.motivo_recusa = detalhe.motivo_recusa || "";

    this.obs.open_form = true;

  };

  isStatusRecusada = () => {
    const status = SugestoesMelhoriasAdminStore.obs.status_sugestao.find(
      (item: any) =>
        Number(item.status) === Number(this.obs.status_selecionado)
    );
    return (status?.nome || "").trim().toLowerCase() === "recusada";
  };

  render() {

    function dataPrevistaFormatter(cell, row) {
      if (!cell) {
        return "Não definida";
      }

      return moment.utc(cell).format("DD/MM/YYYY");
    }

    function dateFormatter(cell, row) {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " às " + moment(cell).add(3, "hour").format("HH:mm");
    };

    const tag_style = this.TAG_STYLE;

    function statusFormatter(cell, row) {

      const status = SugestoesMelhoriasAdminStore.obs.status_sugestao.find(
        (s: any) =>
          Number(s.status) === Number(cell)
      );

      if (!status) {

        return (
          <Tag className="tagConfirmacao" style={{ ...tag_style, background: "#166470", borderColor: "#166470", color: "#fff" }}>NÃO DISPONÍVEL</Tag>
        );
      }

      const nome = status.nome || "";

      const label = nome.charAt(0).toUpperCase() + nome.slice(1);

      const cor = status.color || "#166470";

      return (
        <Tag className="tagConfirmacao" style={{ ...tag_style, background: cor, borderColor: cor, color: "#fff" }}> {label} </Tag>
      );
    }

    const detalhe = this.obs.melhoria_selecionada;

    return (
      <>

        <MDBRow>
          <MDBCol sm="12" md="12" lg="12" xl="12">
            <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10}}>
              <MDBRow>
                <MDBCol md="3">
                  <FormGroup label="Buscar ID">
                    <InputGroup
                      placeholder="Digite o ID"
                      value={this.obs.id}
                      onChange={(e) => (this.obs.id = e.target.value)}
                      fill
                    />
                  </FormGroup>
                </MDBCol>

                <MDBCol md="3">
                  <FormGroup
                    className="inputsPeriodoCalculos"
                    label="Período criação"
                  >
                    <DateRangePicker
                      onChange={this.handleDateSolicitacaoChange}
                      value={this.obs.selectedPeriod}
                    />
                  </FormGroup>
                </MDBCol>

                <MDBCol md="3">
                  <FormGroup
                    className="inputsPeriodoCalculos"
                    label="Período de entrega"
                  >
                    <DateRangePicker
                      onChange={this.handleDateEntregaChange}
                      value={this.obs.selectedDeliveryPeriod}
                    />
                  </FormGroup>
                </MDBCol>

                <MDBCol md="2">
                  <FormGroup label="Situação">
                    <HTMLSelect
                      fill
                      value={this.obs.status_filtro === null ? "" : this.obs.status_filtro}
                      onChange={(e) => {
                        this.obs.status_filtro = e.target.value === "" ? null : Number(e.target.value);
                      }}
                      style={{fontSize: 11, textTransform: "uppercase"}}
                    >
                      <option value="">TODAS</option>

                      {SugestoesMelhoriasAdminStore.obs.status_sugestao.map(
                        (item: any) => (
                          <option
                            key={item.status}
                            value={item.status}
                          >
                            {(item.nome || "").toUpperCase()}
                          </option>
                        )
                      )}
                    </HTMLSelect>
                  </FormGroup>
                </MDBCol>

                <MDBCol md="1">
                  <MDBBtn
                    className="btnDefault btnBuscarNfe mt25"
                    onClick={() => this.handleBuscaSugestao(1)}
                  >
                    Buscar
                  </MDBBtn>
                </MDBCol>
              </MDBRow>

            </div>

            <div data-tut="table">
              <BootstrapTable className="TableDefault" ref="table" data={SugestoesMelhoriasAdminStore.obs.sugestoes}>
                <TableHeaderColumn dataField="_id" width="18%" isKey={true}>ID</TableHeaderColumn>
                <TableHeaderColumn dataField="titulo" width="55%">Título</TableHeaderColumn>
                <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data</TableHeaderColumn>
                <TableHeaderColumn dataFormat={dateFormatter} dataField="updated_at" width="16%"> Atualizado em </TableHeaderColumn>
                <TableHeaderColumn dataFormat={dataPrevistaFormatter} dataField="data_prevista" width="16%"> Data prevista </TableHeaderColumn>
                <TableHeaderColumn dataField="editar" width="8%" dataFormat={(cell, row) => (
                    <MDBBtn
                      color="default"
                      rounded
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleOpenDetalhe(row);
                      }}
                    >
                      <img src="/images/edit.png" width="25px" />
                    </MDBBtn>
                  )}
                  thStyle={{ textAlign: "center" }}
                  tdStyle={{ textAlign: "center" }}
                >
                  Editar
                </TableHeaderColumn>
                <TableHeaderColumn dataFormat={statusFormatter} dataField="status" width="15%"> Status </TableHeaderColumn>
              </BootstrapTable>
            </div>

            <div style={{ marginTop: 5, float: "right", marginBottom: 60 }}>
              <Pager
                currentPage={this.obs.sugestoes_page}
                totalCount={SugestoesMelhoriasAdminStore.obs.sugestoes_length}
                pageSize={15}
                onPageChange={page => this.handleBuscaSugestao(page)}
              />
            </div>
          </MDBCol>
        </MDBRow>

        <Dialog
          isOpen={this.obs.open_form}
          onClose={this.handleCloseForm}
          title="Editar sugestão"
          canOutsideClickClose={true}
          canEscapeKeyClose={true}
          style={{width: 620, maxWidth: "94vw"}}
        >

          <div className={Classes.DIALOG_BODY} style={{maxHeight: "68vh", overflowY: "auto", overflowX: "hidden"}}>

            {detalhe && (
              <MDBRow>

                <MDBCol md="6">
                  <FormGroup label="Situação">

                    <HTMLSelect
                      fill
                      value={this.obs.status_selecionado}
                      onChange={(e) => {
                        this.obs.status_selecionado = Number(e.target.value);

                        if (!this.isStatusRecusada()) {
                          this.obs.motivo_recusa = "";
                        }
                      }}
                      style={{
                        fontSize: 11,
                        textTransform: "uppercase"
                      }}
                    >

                      {SugestoesMelhoriasAdminStore.obs.status_sugestao.map(
                        (item: any) => (
                          <option
                            key={item.status}
                            value={item.status}
                          >
                            {(item.nome || "").toUpperCase()}
                          </option>
                        )
                      )}

                    </HTMLSelect>

                  </FormGroup>
                </MDBCol>

                <MDBCol md="6">
                  <FormGroup label="Data prevista">

                    <LocalizationProvider
                      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                      adapterLocale="pt-br"
                      dateAdapter={AdapterDayjs}
                    >

                      <DatePicker
                        value={this.obs.data_prevista}
                        className="input-data-apuracao"
                        minDate={dayjs().startOf("day")}
                        onChange={(value: Dayjs | null) => {

                          if (value && value.startOf("day").isBefore(dayjs().startOf("day"))) {

                            toast.warning("A data prevista não pode ser anterior à data atual.");

                            this.obs.data_prevista = null;
                            return;
                          }

                          this.obs.data_prevista = value;
                        }}
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            size: "small"
                          },
                          field: {
                            clearable: true,
                            onClear: () => {
                              this.obs.data_prevista = null;
                            }
                          }
                        }}
                      />

                    </LocalizationProvider>

                  </FormGroup>
                </MDBCol>

                {this.isStatusRecusada() && (
                  <MDBCol md="12">
                    <FormGroup label="Motivo da recusa">
                      <TextArea
                        value={this.obs.motivo_recusa}
                        onChange={(e) => {
                          this.obs.motivo_recusa = e.target.value;
                        }}
                        placeholder="Informe o motivo da recusa"
                        rows={4}
                        fill
                      />
                    </FormGroup>
                  </MDBCol>
                )}
              </MDBRow>
            )}

            <FormGroup label="Título">
              <InputGroup value={detalhe ? detalhe.titulo || "" : ""} readOnly disabled fill/>
            </FormGroup>

            <FormGroup label="Detalhes">
              <TextArea value={detalhe ? detalhe.descricao || "" : ""} rows={5} readOnly disabled fill/>
            </FormGroup>

            {detalhe && (

              <FormGroup label="Arquivos">

                {detalhe.arquivos && detalhe.arquivos.length > 0 ? (

                  <div
                    className="sugestao-detalhe-arquivos"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      gap: 10
                    }}
                  >
                    {detalhe.arquivos.map((arquivo: any, i: number) => {
                      return (
                        <div
                          title={arquivo.nome}
                          key={arquivo._id || i}
                          className="sugestao-detalhe-arquivo"
                        >
                          <span>
                            {arquivo.nome.length > 20 
                            ? `${arquivo.nome.slice(0, 20)}...`
                            : `${arquivo.nome}`
                          }
                          </span>

                          <Button
                            icon="download"
                            minimal
                            title={`Baixar ${arquivo.nome}`}
                            onClick={() =>
                              SugestoesMelhoriasAdminStore.handleDownloadArquivo(detalhe._id, i, arquivo.nome)
                            }
                          />
                        </div>
                      );
                    })}
                  </div>

                ) : (

                  <p className="sugestao-detalhe-sem-arquivos">
                    Nenhum arquivo anexado.
                  </p>

                )}

              </FormGroup>

            )}

          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>

            <MDBBtn
              className="btnDefault btnBuscarNfe"
              color="default"
              onClick={this.handleCloseForm}
              disabled={ SugestoesMelhoriasAdminStore.obs.loading }
              style={{marginRight: 10, float: "right"}}
            >
              Cancelar
            </MDBBtn>

            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={this.handleSalvarAlteracoes}
              disabled={SugestoesMelhoriasAdminStore.obs.loading}
              style={{marginRight: 10, float: "right"}}
            >

              {SugestoesMelhoriasAdminStore.obs.loading ? "Salvando..." : "Salvar alterações"}

            </MDBBtn>

          </div>

        </Dialog>

      </>
    );
  }
}